
import React from "react";
import "./About2.css"
import {FiArrowRightCircle} from "react-icons/fi";
import {FiArrowLeftCircle} from "react-icons/fi";
import AboutImage from "../../../Assets/LandingPage/AboutImage.png"
import { Link } from "react-router-dom";

const About2 = () => {
  return (
    <div>
      <div className="landing-about-container">
        <div className="first-landing-about-box">
          <div className="flab first-text-box about2-text">
            <h2>About NYSC SAED </h2>
            <p>The Department is headed by a Director and is made up of two divisions namely:</p>
            <ul className="about-list1">
                <li>Skills Acquisition Division</li>
                <li>Entrepreneurship and Empowerment Division</li>
            </ul>
            <p>Functions of the department include:</p>
            <ul className="about-list2">
                <li>Sensitize and mobilize 200, 000 young graduates for skill acquisition annually</li>
                <li>Facilitate the training and mentoring of 100, 000 young graduates in skill acquisition and entrepreneurship development for self-reliance annually</li>
            </ul>
          </div>
          <img className="about2-image" src={AboutImage} alt="" />
        </div>
        <div className="left-right-arrows">
          <div className="left-arrow lr-arrow"><Link to ="/about" ><FiArrowLeftCircle size={40} style={{color: "#979797"}} /></Link></div>
          <div className="right-arrow lr-arrow"><Link to ="/about3" ><FiArrowRightCircle  size={40} style={{color: "#979797"}} /></Link></div>
        </div>
      </div>
    </div>
  )
}

export default About2